import BookShow from "components/shared/book/show";
import ContactInfo from "components/shared/contactInfo";
import { getCustomNumberConfig } from "components/shared/form";
import { trackerRelationTypesEnum } from "helpers/enums";
import { serializeReq } from "helpers/form";
import { checkMechanic } from "helpers/mechanics";
import { dieselFuelTank } from "helpers/models";
import { viewContainer } from "helpers/redux";
import { trailerNumber } from "helpers/validators";
import { FuelTanks } from "helpers/vehicles/partials";
import { prepareVehicleOwnershipData } from "helpers/vehicles/ownership";
import React from "react";
import { getByPhoneNumber } from "sources/books/mechanics";
import { attach } from "sources/books/trackers";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowTrailer extends BookShow {
    getNumberConfig = (useCustomNumber) => {
        return getCustomNumberConfig({
            number: this.props.config.number,
            useCustomNumber,
            numberValidator: trailerNumber,
        });
    };

    getValidationConfig = (state) => ({
        ...this.props.config,
        number: this.getNumberConfig(!!state.useCustomNumber),
    });

    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        source.getItem(match.params).then((data) => {
            if (!data.fuelTanks || data.fuelTanks.length === 0) {
                data.fuelTanks = [{ ...dieselFuelTank }];
            }
            data.useCustomNumber = !!trailerNumber(data.number).length;
            this.setState({ data, initial: data, ...defParams });
        });
    };

    setCustomNumberMode = ({ value }) => {
        const { data, initial } = this.state;
        const number = value ? data.number : "";
        const nextData = { ...data, number, useCustomNumber: value };
        let shouldUpdate = false;
        for (const key in data) {
            if (initial[key] !== nextData[key]) {
                shouldUpdate = true;
                break;
            }
        }
        const isValid = this.isValidForm(nextData);
        this.setState({ data: nextData, shouldUpdate, ...(isValid ? { isValid: true } : {}) });
    };

    actionPrint = () => {
        const { modal, config, profile } = this.props;
        return modal({
            name: "print",
            title: "Печать прицепа",
            CustomBody: Markup,
            bodyData: {
                ...config,
                values: this.state.initial,
                renderMechanic: this.renderMechanic,
                data: this.state.data,
                organizationName: profile.organizationName,
                ownershipDisabled: true,
            },
        });
    };

    renderBody = () => {
        const { config, profile, refuelingSettings } = this.props;
        return (
            <Markup
                {...config}
                data={this.state.data}
                setValue={this.setValue}
                setCustomNumberMode={this.props.canEditBooks ? this.setCustomNumberMode : undefined}
                renderField={this.renderField}
                renderSelect={this.renderSelect}
                renderMechanic={this.renderMechanic}
                renderFuelTanks={this.renderFuelTanks}
                renderCheckbox={this.renderCheckbox}
                availableFeatureModules={profile.availableFeatureModules}
                organizationName={profile.organizationName}
                ownershipDisabled={!this.props.canEditBooks}
                refuelingSettings={refuelingSettings}
                Button={this.renderButton}
            />
        );
    };

    renderMechanic = () => {
        const props = {
            renderField: this.renderField,
            contact: this.state.data.mechanic,
            setValue: this.setValue,
            config: this.props.config.mechanic,
            getContactInfo: getByPhoneNumber,
            fieldName: "mechanic",
        };
        return <ContactInfo {...props} />;
    };

    renderFuelTanks = () => {
        const { modal, config, canEditBooks, roles } = this.props;
        const props = {
            modal,
            canEditBooks,
            roles,
            config: config.fuelTanks,
            fuelTanks: this.state.data.fuelTanks || [],
            setValue: this.setValue,
        };

        return <FuelTanks {...props} />;
    };

    apply = () => {
        const { source, match, config } = this.props;
        const { isLoading, shouldUpdate, data, initial } = this.state;
        const { id, trackerId } = data;
        const initialTrackerid = initial.trackerId;

        const attachCurrentTracker = (id, trackerId) => {
            if (trackerId) {
                return this.attachTracker({ type: trackerRelationTypesEnum.Trailer, entityId: id, id: trackerId }).then(
                    () => this.getItem(this.props),
                );
            } else {
                this.setState({ isLoading: false, isValid: false });
                return Promise.all([]);
            }
        };

        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(data)) {
                this.setState({ isLoading: true, isValid: true });
                checkMechanic(data);

                let promise = null;
                if (initialTrackerid !== trackerId) {
                    if (!!initialTrackerid && !!trackerId) {
                        promise = this.attachTracker({
                            type: trackerRelationTypesEnum.Trailer,
                            entityId: null,
                            id: initialTrackerid,
                        }).then((res) => res && attachCurrentTracker(id, trackerId));
                    } else {
                        promise = this.attachTracker({
                            type: trackerRelationTypesEnum.Trailer,
                            entityId: trackerId ? id : null,
                            id: initialTrackerid || trackerId,
                        });
                    }
                } else {
                    promise = Promise.all([]);
                }

                const { useCustomNumber, ...requestData } = prepareVehicleOwnershipData(data);

                return promise
                    .then(() => {
                        source
                            .apply(serializeReq({ id: match.params, ...requestData }, config))
                            .then((res) => res && this.update(this.props.mergeParams))
                            .then(() => this.setState({ isLoading: false, isValid: false }))
                            .catch(() => this.setState({ isLoading: false, isValid: false }));
                    })
                    .catch(() => this.setState({ isLoading: false, isValid: false }));
            }
            this.setState({ isValid: false });
        }
    };

    attachTracker = (params) => {
        return attach(params);
    };
}

const ConfiguredShow = (props) => <ShowTrailer {...props} config={config} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "trailers");
